<ng-container *transloco="let t">
  @if (isOpen()) {
    @if (isBottomSheet()) {
      <!-- Native mobile bottom sheet -->
      <div
        class="fixed inset-0 bg-black/50 z-[10001] flex items-end"
        role="dialog"
        aria-modal="true"
        tabindex="0"
        (click)="onBackdropClick($event)"
        (keydown.escape)="onStayClick()"
      >
        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
        <div
          class="w-full bg-white rounded-t-2xl bottom-sheet-slide-up flex flex-col"
          style="padding-bottom: env(safe-area-inset-bottom, 0px)"
          role="document"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-center justify-between px-4 py-3 bg-black rounded-t-2xl shrink-0">
            <div class="flex items-center gap-2">
              <img [src]="heroiconsWarning" alt="Warning" class="w-5 h-5" />
              <span class="font-dm text-base font-semibold text-white">
                {{ customTitle() ?? t(titleKey) }}
              </span>
            </div>
            <button
              type="button"
              class="flex items-center justify-center size-8 bg-transparent border-none cursor-pointer"
              aria-label="Close"
              (click)="onStayClick()"
            >
              <ld-svg-icon [src]="closeIcon" class="size-6 [--stroke-0:white]" aria-hidden="true" />
            </button>
          </div>

          <div class="px-6 py-6">
            <p class="font-dm text-sm text-ld-neutral-500 m-0">
              {{ customMessage() ?? t(messageKey) }}
            </p>
          </div>

          <div class="px-6 pb-6 flex flex-col gap-3">
            <button
              id="unsaved-changes-modal-stay-btn"
              type="button"
              class="btn-primary-ld-purple w-full"
              (click)="onStayClick()"
            >
              {{ customStayButtonLabel() ?? t(stayButtonKey) }}
            </button>

            <button
              id="unsaved-changes-modal-leave-btn"
              type="button"
              class="btn-outline-ld-purple w-full"
              (click)="onLeaveClick()"
            >
              {{ customLeaveButtonLabel() ?? t(leaveButtonKey) }}
            </button>
          </div>
        </div>
      </div>
    } @else {
      <!-- Desktop / web centered modal -->
      <ld-base-modal [title]="customTitle() ?? t(titleKey)" [showCloseButton]="false" (closeModal)="onStayClick()">
        <div modal-content>
          <div id="unsaved-changes-modal-icon" class="flex justify-center mb-4">
            <img [src]="heroiconsWarning" alt="Warning" class="w-10 h-10" />
          </div>

          <p id="unsaved-changes-modal-message" class="text-body text-ld-neutral-500 text-center mb-6">
            {{ customMessage() ?? t(messageKey) }}
          </p>
        </div>

        <div modal-footer>
          <button
            id="unsaved-changes-modal-stay-btn"
            type="button"
            class="btn-primary-ld-purple w-full"
            (click)="onStayClick()"
          >
            {{ customStayButtonLabel() ?? t(stayButtonKey) }}
          </button>

          <button
            id="unsaved-changes-modal-leave-btn"
            type="button"
            class="btn-solid-red w-full"
            (click)="onLeaveClick()"
          >
            {{ customLeaveButtonLabel() ?? t(leaveButtonKey) }}
          </button>
        </div>
      </ld-base-modal>
    }
  }
</ng-container>
